import React from 'react';
import * as token from '../../../../util/tokenUtil';
import * as apiUtil from '../../../../util/apiUtil';
import SelectList from "../../../../component/input/SelectList";

class CategorySelectComp extends React.Component {
    constructor(props){
        super(props);

        this.ajaxGetMainCate = this.ajaxGetMainCate.bind(this);
        this.ajaxGetMidCate = this.ajaxGetMidCate.bind(this);
        this.ajaxGetSubMainCate = this.ajaxGetSubMainCate.bind(this);
        this.ajaxGetSubCate = this.ajaxGetSubCate.bind(this);
        this.ajaxGetCateID = this.ajaxGetCateID.bind(this);

        this.handleChangeCate = this.handleChangeCate.bind(this);


        this.changeToLabelList = this.changeToLabelList.bind(this);

        this.state = {
            mainCategories:[],
            midCategories: [],
            subCategories: []
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.mainCategories !== nextState.mainCategories
            || this.state.midCategories !== nextState.midCategories
            || this.state.subCategories !== nextState.subCategories
            || this.props.main !== nextProps.main
            || this.props.mid !== nextProps.mid
            || this.props.sub !== nextProps.sub
        )
    }

    async componentDidMount() {
        if(token.getAccessToken()) this.ajaxGetCateID();
        else await this.ajaxGetMainCate();
        // await this.ajaxGetMidCate(1);
        // await this.ajaxGetSubCate(1);
    }

    async ajaxGetMainCate () {
        await fetch(process.env.REACT_APP_API_BASE_URL + "/api/category/main")
            .then(res => res.json())
            .then(result => this.setState({
                ...this.state,
                mainCategories: this.changeToLabelList(result)
            }));
    }
    async ajaxGetMidCate (id) {
        if (! id) {
            this.setState({ midCategories: [] });
            this.setState({ subCategories: [] });
            return;
        }

        await fetch(process.env.REACT_APP_API_BASE_URL + "/api/category/mid/" + id)
            .then(res => res.json())
            .then(result => this.setState({
                ...this.state,
                midCategories: this.changeToLabelList(result),
                subCategories: [],
            }));
    }
    async ajaxGetSubCate(id) {
        if (! id) {
            this.setState({ subCategories: [] });
            return;
        }

        await fetch(process.env.REACT_APP_API_BASE_URL + "/api/category/sub/" + id)
            .then(res => res.json())
            .then(result => this.setState({
                ...this.state,
                subCategories: this.changeToLabelList(result)
            }));
    }
    async ajaxGetSubMainCate(id) {
        await fetch(process.env.REACT_APP_API_BASE_URL + "/api/category/submain/" + id)
            .then(res => res.json())
            .then(result => this.setState({
                ...this.state,
                subCategories: this.changeToLabelList(result)
            }));
    }

    async handleChangeCate(id, value) {
        const { setCateValue } = this.props;
        switch (id) {
            case "main":
                setCateValue("main", value);
                setCateValue("mid", "");
                setCateValue("sub", "");
                await this.ajaxGetMidCate(value);
                break;
            case "mid":
                setCateValue("mid", value);
                setCateValue("sub", "");
                await this.ajaxGetSubCate(value);
                break;
            case "sub":
                setCateValue("sub", value);
                break;
            default:
                break;
        }
    }

    ajaxGetCateID() {
        const { setCateValue } = this.props;
        apiUtil.asyncRequest({
            url: '/api/category/get/categoryIds',
            method: apiUtil.requestMethod.GET,
            success: async (result) => {
                await setCateValue("main", result.mainCategoryId);
                await setCateValue("mid", result.midCategoryId);
                await setCateValue("sub", result.subCategoryId);
                await this.ajaxGetMainCate();
                await this.ajaxGetMidCate(result.mainCategoryId);
                await this.ajaxGetSubCate(result.midCategoryId);
            }
        })
    }

    changeToLabelList(list) {
        return list.map(item => { return { label: item.name , value: item.uid }; });
    }

    render() {
        const { disabled } = this.props;
        const { main, mid, sub } = this.props;
        const { mainCategories, midCategories, subCategories } = this.state;

        const { handleChangeCate } = this;

        return(
            <div className='d-flex'>
                <SelectList
                    defaultLabel={"대분류 선택"}
                    className={"form-select d-inline me-1"}
                    name="midCates"
                    id={"main"}
                    onChange={handleChangeCate}
                    disabled={disabled !== undefined}
                    list={mainCategories}
                    value={main}
                    disabledDefault={true}
                />
                <SelectList
                    defaultLabel={"중분류 선택"}
                    className={"form-select d-inline mx-1"}
                    name="midCates"
                    id={"mid"}
                    onChange={handleChangeCate}
                    disabled={disabled !== undefined}
                    list={midCategories}
                    value={mid}
                />
                <SelectList
                    defaultLabel={"소분류 선택"}
                    className={"form-select d-inline mx-1"}
                    name="subCate"
                    id={"sub"}
                    onChange={handleChangeCate}
                    disabled={disabled !== undefined}
                    list={subCategories}
                    value={sub}
                />
            </div>
        )
    }
}

export default CategorySelectComp;
